import {
    friend1,
    friend2,
    friend4,
    friend3,
    friend5,
    friend6
} from "helper/constant";

export const contactList = [
    {
        id: 1,
        name: "Aaron Hank",
        profile: friend1,
        email: "aaronnhank@gmail.com",
        mobile: "+18278272727",
        isfav: false,
        isfrequent: true
    },
    {
        id: 2,
        name: "Bacon Francis",
        profile: friend2,
        email: "baconfrancis@gmail.com",
        mobile: "+19287372662",
        isfav: true,
        isfrequent: false
    },
    {
        id: 3,
        name: "Barnes Julian",
        profile: null,
        email: "barnesjulian367@gmail.com",
        mobile: "+18393746789",
        isfav: false,
        isfrequent: true
    },
    {
        id: 4,
        name: "Capote Truman",
        profile: friend4,
        email: "capote647@gmail.com",
        mobile: "+19283746536",
        isfav: false,
        isfrequent: false
    },
    {
        id: 5,
        name: "Delacroix Eugène",
        profile: friend5,
        email: "delacroix@gmail.com",
        mobile: "+13928928288",
        isfav: true,
        isfrequent: true
    },
    {
        id: 6,
        name: "Deng Xiaoping",
        profile: friend6,
        email: "dengxiaoping@gmail.com",
        mobile: "+16754445567",
        isfav: true,
        isfrequent: false
    },
    {
        id: 7,
        name: "Dhaver Caroline",
        profile: friend1,
        email: "caroline@gmail.com",
        mobile: "+15849272727",
        isfav: false,
        isfrequent: true
    },
    {
        id: 8,
        name: "Frostrup",
        profile: friend2,
        email: "frostrup@gmail.com",
        mobile: "+15564532345",
        isfav: true,
        isfrequent: true
    },
    {
        id: 9,
        name: "Gay John",
        profile: friend3,
        email: "gaujohn@gmail.com",
        mobile: "+15566445555",
        isfav: false,
        isfrequent: true
    },
    {
        id: 10,
        name: "Hašek Jaroslav",
        profile: friend6,
        email: "hasek467@gmail.com",
        mobile: "+19587372662",
        isfav: false,
        isfrequent: true
    },
    {
        id: 11,
        name: "Heming",
        profile: friend5,
        email: "heming@gmail.com",
        mobile: "+16543324456",
        isfav: false,
        isfrequent: true
    },
    {
        id: 12,
        name: "Izzard Eddie",
        profile: friend4,
        email: "izzard@gmail.com",
        mobile: "+17654544455",
        isfav: true,
        isfrequent: false
    },
    {
        id: 13,
        name: "Jackson Michael",
        profile: friend1,
        email: "jackson@gmail.com",
        mobile: "+65333333222",
        isfav: true,
        isfrequent: false
    },
    {
        id: 14,
        name: "Keats John",
        profile: friend2,
        email: "keatsjohn@gmail.com",
        mobile: "+18787864444",
        isfav: true,
        isfrequent: false
    }
];
